/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export const regexConstants = {
  uniqueIdNumberPattern: /^(?!.*\s)(?=.*\d.*\d)[a-zA-Z0-9.\-_/\\]+$/,
  licensePlatePattern: '[0-9A-Z]{2,20}'
}
